import { ESignatureIntegrationCard as ESignatureIntegrationCardV2 } from '~/features/admin/ESignature/ESignatureIntegrationCard/ESignatureIntegrationCard';
import { useESignatureIntegrationData } from '~/features/admin/ESignature/utils/ESignatureIntegrations/useESignatureIntegration';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { withCurrentUser } from '~/hocs/withCurrentUser';
import { useIntl } from 'react-intl';
import CardList from '~/ui/components/CardList/CardList';
import LoadingContainer from '~/ui/components/LoadingContainer/LoadingContainer';
import Text from '~/ui/components/Text/Text';

import ESignatureIntegrationCardV1 from './ESignatureIntegrationCard/ESignatureIntegrationCard';

function ESignatureIntegrations({ currentUser }) {
  const intl = useIntl();

  const isESignatureV2Enabled = useFlag(FlagType.EsignatureV2Revamp);

  const {
    esignatureIntegrations,
    isLoading,
    activeEsignatureIntegrationCount,
    handleRefetch,
    errorMessage,
  } = useEsignatureIntegrationsView({
    currentUser,
    isV2: isESignatureV2Enabled,
    intl,
  });

  const ESignatureCard = isESignatureV2Enabled
    ? ESignatureIntegrationCardV2
    : ESignatureIntegrationCardV1;

  return (
    <CardList
      title={intl.formatMessage({
        id: 'ESignatureIntegrations.title',
        defaultMessage: 'Electronic Signatures',
        description: 'Title for electronic signatures section',
      })}
    >
      {errorMessage ? (
        <Text variant="m-spaced">{errorMessage}</Text>
      ) : (
        <LoadingContainer isLoading={isLoading}>
          {esignatureIntegrations.map((integration) => (
            <ESignatureCard
              key={integration.id}
              activeEsignatureIntegrationCount={
                activeEsignatureIntegrationCount
              }
              esignatureIntegration={integration}
              isRefetching={false}
              onRefetch={handleRefetch}
            />
          ))}
        </LoadingContainer>
      )}
    </CardList>
  );
}

function useEsignatureIntegrationsView({ currentUser, isV2, intl }) {
  const { integrationsMap, isLoading, error, refetch } =
    useESignatureIntegrationData(currentUser, isV2);

  const esignatureIntegrations = Object.values(integrationsMap);

  const activeEsignatureIntegrationCount = esignatureIntegrations.filter(
    (integration) => integration.id && !integration.id.startsWith('mock-'),
  ).length;

  const errorMessage =
    error &&
    intl.formatMessage({
      id: 'ESignatureIntegrations.fetchError',
      defaultMessage:
        'Unable to fetch third party integrations, please try again.',
      description: 'Error message when integrations fail to load',
    });

  return {
    esignatureIntegrations,
    isLoading,
    activeEsignatureIntegrationCount,
    handleRefetch: refetch,
    errorMessage,
  };
}
export default withCurrentUser(ESignatureIntegrations);
